export default "__VITE_ASSET__8d00c2ca__"